import { Encouragement } from 'src/app/data/patient/domain/encouragement/encouragement';
import { Diary } from 'src/app/data/tracker/domain/diary/diary';

export class DiaryDayModel {
  label: string;
  date: number;
  encouragements: Encouragement[];
  diaries: Diary[];

  constructor(
    label: string,
    date: number,
    encouragements: Encouragement[],
    diaries: Diary[],
  ) {
    this.label = label;
    this.date = date;
    this.encouragements = encouragements;
    this.diaries = diaries;
  }
}
